<link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet">

<section class="hero-section">
    <div class="card-grid">
        <!-- Primul articol promo -->
        <div class="card_prim">
            <div class="card__background" style="background-image: url(/assets/pics/tuja/TuiaSmaragd.jpg)">
            </div>
            <div class="card__content">
                <p class="card__category">PROMOTIE</p>
                <h3 class="card__heading">Tuia smaragd </h3>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-modal" data-toggle="modal"
                    data-target="#staticBackdrop">Detalii</button>

                <!-- Modal -->
                <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Reducere</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row modal_h1">
                                    <h1 class="modal_text">La fiecare 5 bucati de Tuia Smaragd primiti 1 gratis </h1>
                                    <h1 class="modal_text">Pentru tuia cu inaltimi intre 120-140cm </h1>
                                </div>
                                <div class="row modal_img">
                                    <img class="pozaPromo" src="/assets/pics/tuja/TuiaSmaragd.jpg"
                                        alt="tuia smaragd la ghiveci">
                                </div>


                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Inchide</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card_title">

                </div>
            </div>
        </div>
        <!-- Al doilea articol promo -->
        <div class="card_prim">
            <div class="card__background"
                style="background-image: url(/assets/pics/plante_diverse/tisataxusbacata.jpg)">
            </div>
            <div class="card__content">
                <p class="card__category">PROMOTIE</p>
                <h3 class="card__heading">Taxux Bacata Tisa</h3>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-modal" data-toggle="modal" data-target="#staticBackdrop1">
                    Detalii
                </button>

                <!-- Modal -->
                <div class="modal fade" id="staticBackdrop1" data-backdrop="static" data-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Reducere</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <div class="row modal_h1">
                                    <h1 class="modal_text">La fiecare 5 bucati de Taxus Bacata Fastigiata(Tisa) primiti
                                        unul gratis</h1>

                                </div>
                                <div class="row modal_img">
                                    <img class="pozaPromo" src="/assets/pics/plante_diverse/tisataxusbacata.jpg"
                                        alt="taxus bacata">
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Inchide</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Al treilea articol promo -->
        <div class="card_prim">
            <div class="card__background" style="background-image: url(/assets/pics/tuja/TuiaSmaragd.jpg)">
            </div>
            <div class="card__content">
                <p class="card__category">PROMOTIE</p>
                <h3 class="card__heading">Tuia smaragd </h3>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-modal" data-toggle="modal"
                    data-target="#staticBackdrop2">Detalii</button>

                <!-- Modal -->
                <div class="modal fade" id="staticBackdrop2" data-backdrop="static" data-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Reducere</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row modal_h1">
                                    <h1 class="modal_text">La fiecare 5 bucati de Tuia Smaragd primiti 1 gratis </h1>
                                    <h1 class="modal_text">Pentru tuia cu inaltimi intre 140-160cm </h1>
                                </div>
                                <div class="row modal_img">
                                    <img class="pozaPromo" src="/assets/pics/tuja/TuiaSmaragd.jpg"
                                        alt="tuia smaragd la ghiveci">
                                </div>


                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Inchide</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card_title">

                </div>
            </div>
        </div>
        <!-- Al 4 -lea articol promo -->
        <div class="card_prim">
            <div class="card__background" style="background-image: url(/assets/pics/flori/trandafir.jpg)">
            </div>
            <div class="card__content">
                <p class="card__category">PROMOTIE</p>
                <h3 class="card__heading">Trandafir pe picior</h3>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-modal" data-toggle="modal"
                    data-target="#staticBackdrop3">Detalii</button>
    
                <!-- Modal -->
                <div class="modal fade" id="staticBackdrop3" data-backdrop="static" data-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Reducere</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row modal_h1">
                                    <h1 class="modal_text">La fiecare 5 bucati de Trandafir primiti 1 gratis </h1>
                                   
                                </div>
                                <div class="row modal_img">
                                    <img class="pozaPromo" src="/assets/pics/flori/trandafir.jpg"
                                        alt="Trandafir pe picior">
                                </div>
    
    
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Inchide</button>
    
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card_title">
    
                </div>
            </div>
        </div>
<!--         
        <div class="card_prim">
            <div class="card__background" style="background-image: url(/assets/pics/plante_diverse/artar.jpg)">
            </div>
            <div class="card__content">
                <p class="card__category">PROMOTIE</p>
                <h3 class="card__heading">Trandafir pe picior</h3>
 -->

                <!-- Button trigger modal -->

<!-- 
                <button type="button" class="btn btn-modal" data-toggle="modal" data-target="#staticBackdrop3">
                    Detalii
                </button> -->



                <!-- Modal -->


                <!-- <div class="modal fade" id="staticBackdrop3" data-backdrop="static" data-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Reducere</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <h1>La fiecare 5 Trandafiri primiti o planta la alegere din lista de mai jos.</h1>

                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center" type="button"
                                                    data-toggle="collapse" data-target="#collapseOne"
                                                    aria-expanded="true" aria-controls="collapseOne">
                                                    Carexbronze
                                                </button>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img"
                                                    src="/assets/pics/plante_diverse/carexbronze.jpg" alt="carexbronze">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingTwo">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center collapsed"
                                                    type="button" data-toggle="collapse" data-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo">
                                                    Festuca
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img" src="/assets/pics/plante_diverse/iarba2.jpg"
                                                    alt="iarba2">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingThree">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center collapsed"
                                                    type="button" data-toggle="collapse" data-target="#collapseThree"
                                                    aria-expanded="false" aria-controls="collapseThree">
                                                    Iarba3
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img" src="/assets/pics/plante_diverse/iarba3.jpg"
                                                    alt="Iarba3">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingFour">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center collapsed"
                                                    type="button" data-toggle="collapse" data-target="#collapseFour"
                                                    aria-expanded="false" aria-controls="collapseFour">
                                                    iarba4
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img" src="/assets/pics/plante_diverse/iarba4.jpg"
                                                    alt="iarba4">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingFive">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center collapsed"
                                                    type="button" data-toggle="collapse" data-target="#collapseFive"
                                                    aria-expanded="false" aria-controls="collapseFive">
                                                    Buxus bicolor
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img"
                                                    src="/assets/pics/plante_diverse/buxusbicolor.jpg"
                                                    alt="buxusbicolor">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingSix">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block text-center collapsed"
                                                    type="button" data-toggle="collapse" data-target="#collapseSix"
                                                    aria-expanded="false" aria-controls="collapseSix">
                                                    Hemerocallisyounique
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseSix" class="collapse" aria-labelledby="headingSix"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <img class="accordion_img"
                                                    src="/assets/pics/plante_diverse/hemerocallisyounique.jpg"
                                                    alt="hemerocallisyounique">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Inchide</button>

                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- </div> -->
        <!-- </div> -->

    </div>

 
</section>